export function OPEN_FILE_INFO (file_id) {
  return `/api/v2/file/${file_id}/info`
}

export const OPEN_PREVIEW_TOKEN = '/api/v2/file/preview_token'
export const OPENPLATFORM_PRESIGN_UPLOAD = '/api/v2/file/upload'
export const OPENPLATFORM_PRESIGN_UPLOAD_BY_PATH = '/api/v2/file/upload_by_path'
export const OPENPLATFORM_ITEM_INFO = '/api/v2/file/%s/info'
